import React, { FC, ReactNode, useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import { CircleMenu } from './CircleMenu';

const TOP_ANG = -Math.PI / 2;
const STEP_ANG = Math.PI / 6;

export type ItemMenuComponentType<T> = {
  title: T | string;
  icon?: ReactNode;
  onClickMenuItem?: () => void;
};
interface PropsMenu {
  positionX: number;
  positionY: number;
  itemsMenu: Array<ItemMenuComponentType<string>>;
  closeMenu(): void;
}
export const MenuComponent: FC<PropsMenu> = ({ itemsMenu, positionX, positionY, closeMenu }) => {
  const itemsMenuRef = useRef<Array<HTMLDivElement | null>>([]);
  const containerMenuRef = useRef<HTMLDivElement>();

  const handlerOpenMenu = () => {
    const countLeft = Math.floor(itemsMenuRef.current.length / 2);
    const offsetRight = countLeft % 2 > 0 ? Math.PI / 12 : 0;
    const startAngle = TOP_ANG - countLeft * STEP_ANG + offsetRight;

    itemsMenuRef.current.map((item, i) => {
      if (item) {
        const y = 100 * Math.sin(startAngle + STEP_ANG * i);
        const x = 100 * Math.cos(startAngle + STEP_ANG * i);
        item.style.transform = `translate(${x}px,${y}px)`;
        item.style.opacity = '1';
      }
    });
  };
  const handlerCloseMenu = (callback?: () => void) => {
    itemsMenuRef.current.map(item => {
      if (item) {
        item.style.transform = `translate(0px,0px)`;
        item.style.opacity = `0`;
      }
    });
    setTimeout(() => {
      if (callback) {
        callback();
      }
      closeMenu();
    }, 500);
  };

  const stopContextMenu = (evt: Event) => {
    evt.preventDefault();
  };

  useEffect(() => {
    handlerOpenMenu();
    if (containerMenuRef) {
      containerMenuRef.current?.addEventListener('contextmenu', stopContextMenu);
    }

    return () => {
      if (containerMenuRef) {
        containerMenuRef.current?.removeEventListener('contextmenu', stopContextMenu);
      }
    };
  }, []);

  return (
    <Box
      ref={containerMenuRef}
      position="fixed"
      top={positionY}
      left={positionX}
      width="1px"
      height="1px"
      bgcolor="#ff00ff"
    >
      {itemsMenu.map((item, index) => (
        <CircleMenu
          key={index.toString()}
          ref={element => (itemsMenuRef.current[index] = element)}
          position_x="-45px"
          position_y="-20px"
          onClick={() => handlerCloseMenu(item?.onClickMenuItem)}
        >
          {item.icon}
        </CircleMenu>
      ))}
    </Box>
  );
};
